import React from "react";
import { makeStyles } from "@material-ui/styles";
import OtpInput from "react-otp-input";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFFFF",
    borderRadius: "10px",
    flex: "none",
    order: 1,
    alignSelf: "stretch",
    flexGrow: 1,
    marginBottom: "24px",
    marginTop: "24px",
  },
  customInput: {
    border: 0,
    fontSize: "30px",
    height: 19,
    width: "53px !important",
    border: "none",
    height: "84px !important",
    borderRadius: "10px",
    textAlign: "center",
    "&:focus-visible": {
      outline: 0,
    },
    "&[value='']": {
      width: "53px !important",
      height: "84px !important",
      borderRadius: "10px",
    },
  },
}));

export default function FruProOTPInput(props) {
  const classes = useStyles();

  return (
    <>
      <OtpInput
        containerStyle={classes.root}
        inputStyle={classes.customInput}
        {...props}
      />
    </>
  );
}
